module.exports = __webpack_public_path__ + "static/img/home_style2.5d427471.png";